import { useContext, useState } from 'react'

import { useTotalsRowInputs } from '@pages/TimeLineCreateOrEdit/hooks/useTotalsRowInputs'

import { FormCommand } from '@types'

import { PageContext } from '../TimeLineCreateOrEdit'

type UseObjectXTotalsRow = {
  rowIndex: number
}

export const useObjectXTotalsRow = (props: UseObjectXTotalsRow) => {
  const { rowIndex } = props

  const {
    state: {
      methods: { watch, setValue },
    },
  } = useContext(PageContext)

  const [showScriptDialog, setShowScriptDialog] = useState(false)
  const [showAddCommandsDialog, setShowAddCommandsDialog] = useState(false)

  const titleFieldName = `objectX.totalsRows.${rowIndex}.title` as const
  const scriptFieldName = `objectX.totalsRows.${rowIndex}.script` as const
  const commandsFieldName = `objectX.totalsRows.${rowIndex}.commands` as const
  const bindTypeFieldName = `objectX.totalsRows.${rowIndex}.bindType` as const

  const watchTitle = watch(titleFieldName)
  const watchId = watch(`objectX.totalsRows.${rowIndex}.id`)
  const watchBindType = watch(`objectX.totalsRows.${rowIndex}.bindType`)
  const watchScript = watch(scriptFieldName)
  const watchCommands = watch(commandsFieldName)

  const handleChangeScript = (value: string) => {
    setValue(scriptFieldName, value, { shouldDirty: true, shouldValidate: true })
  }

  const handleChangeShowScriptDialog = (value?: boolean) => {
    setShowScriptDialog(Boolean(value))
  }

  const handleChangeCommands = (commands?: FormCommand[] | null) => {
    setValue(commandsFieldName, commands as FormCommand[], { shouldDirty: true })
  }

  const handleChangeShowAddCommandsDialog = (value: boolean) => {
    setShowAddCommandsDialog(value)
  }

  const handleCloseAddCommandsDialog = () => {
    handleChangeShowAddCommandsDialog(false)
  }

  const handleOpenAddCommandsDialog = () => {
    handleChangeShowAddCommandsDialog(true)
  }

  const { inputs } = useTotalsRowInputs({
    titleFieldName,
    scriptFieldName,
    bindTypeFieldName,
    handleChangeShowScriptDialog,
    handleOpenAddCommandsDialog,
  })

  return {
    state: {
      watchId,
      watchTitle,
      watchBindType,
      watchScript,
      watchCommands,
      showScriptDialog,
      showAddCommandsDialog,
    },
    handlers: {
      handleChangeScript,
      handleChangeShowScriptDialog,
      handleChangeCommands,
      handleChangeShowAddCommandsDialog,
      handleOpenAddCommandsDialog,
      handleCloseAddCommandsDialog,
    },
    data: {
      titleFieldName,
      commandsFieldName,
    },
    inputs,
  }
}
